var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69035 5.80295C7.53653 5.96237 7.38975 6.13222 7.25 6.3125C6.41667 7.3875 6 8.61667 6 10V17H4V19H20V18.1126L18.8874 17H18V16.1126L7.69035 5.80295Z",
    fill: "#FF7A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.2842V10C18 8.61667 17.5833 7.3875 16.75 6.3125C15.9167 5.2375 14.8333 4.53333 13.5 4.2V3.5C13.5 3.08333 13.3542 2.72917 13.0625 2.4375C12.7708 2.14583 12.4167 2 12 2C11.5833 2 11.2292 2.14583 10.9375 2.4375C10.6458 2.72917 10.5 3.08333 10.5 3.5V4.2C10.0868 4.30329 9.69767 4.44219 9.33252 4.6167L18 13.2842Z",
    fill: "#FF7A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5875 21.4125C10.9792 21.8042 11.45 22 12 22C12.55 22 13.0208 21.8042 13.4125 21.4125C13.8042 21.0208 14 20.55 14 20H10C10 20.55 10.1958 21.0208 10.5875 21.4125Z",
    fill: "#FF7A00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.36816,
    y: 2.4541,
    width: 24,
    height: 2,
    transform: "rotate(45 4.36816 2.4541)",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsOff);
export default __webpack_public_path__ + "static/media/notifications_off.56617effbe9af15b2040add13374d303.svg";
export { ForwardRef as ReactComponent };